module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_oval_black.cddd6296.png";